export function getSearchParam(url: URL, param: string): string {
  const paramValue = url.searchParams.get(param);
  if (paramValue != null) {
    return paramValue;
  }
  return '';
}

export function getQueryParamURL(): URL {
  const splittedHash = window.location.href.split('?');
  if (splittedHash.length > 1) {
    return new URL(`http://localhost?${splittedHash[1]}`);
  }
  return new URL(`http://localhost`);
}

export function getCurrentPath(): string {
  return window.location.pathname;
}

export function getCurrentPathWithoutHash(): string {
  const curURL = new URL(window.location.href);
  const splitted = curURL.hash.split('?');
  return splitted[0].replace('#', '');
}

export function addHistory(filter: string): void {
  const newurl =
    window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    '?' +
    filter;
  window.history.pushState({ path: newurl }, '', newurl);
}
